// Mock data for GoldrushAi Clone

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'What We Do', href: '#comparison' },
  { label: 'Contact', href: '#booking' }
];

export const traditionalProblems = [
  {
    title: 'Manual Processes',
    description: 'Your team is drowning in calls, emails, and tasks, manually managing every customer inquiry.'
  },
  {
    title: 'Missed Opportunities',
    description: 'Limited hours and stretched resources mean leads slip through the cracks.'
  },
  {
    title: 'Time-Consuming Sorting',
    description: 'Hours are wasted qualifying leads and sorting through irrelevant inquiries.'
  },
  {
    title: 'High Overhead Costs',
    description: "You're forced to hire more staff just to keep up with routine tasks."
  },
  {
    title: 'Slow Responses',
    description: 'Customers are left waiting, leading to frustration and lost trust.'
  }
];

export const futureflowBenefits = [
  {
    title: 'Speed-to-Lead Advantage',
    description: 'Inbound inquiries from ads, forms, or calls are responded to within 60 seconds—increasing conversions by 20x or more.'
  },
  {
    title: 'Capture Every Opportunity',
    description: 'With round-the-clock availability, inquiries are managed without delay, ensuring no leads slip away.'
  },
  {
    title: 'Smart Lead Qualification',
    description: 'AI filters out irrelevant inquiries and delivers only the most promising leads to your team.'
  },
  {
    title: 'Lower Operational Costs',
    description: 'Our system will cost less than 1 employee or any 3rd party call centre.'
  },
  {
    title: 'Consistent Follow-Up',
    description: 'The AI can do the tiresome follow ups your team hates doing. Pursuing every lead with consistent persistence until they convert or opt out.'
  }
];

export const features = [
  {
    id: 1,
    title: 'CRM Integration',
    description: 'Our systems are flexible. We can adapt it to fit with your existing workflows or CRM software.',
    type: 'crm'
  },
  {
    id: 2,
    title: 'Calendar Booking',
    description: 'Books qualified prospects directly into your calendar without back-and-forth emails.',
    type: 'calendar'
  },
  {
    id: 3,
    title: 'Lead Qualification',
    description: 'Pre-screens every caller using your specific criteria before passing them to your team.',
    type: 'lead'
  },
  {
    id: 4,
    title: 'Multi-Call Handling',
    description: 'Handles 10+ conversations simultaneously - no more busy signals or missed calls.',
    type: 'multicall'
  },
  {
    id: 5,
    title: 'Multi-Lingual Agents',
    description: 'Our Agents can communicate in 20+ different languages professionally.',
    type: 'multilingual'
  },
  {
    id: 6,
    title: '24/7 Availability',
    description: 'Captures leads around the clock, including weekends, holidays, and after business hours.',
    type: 'availability'
  }
];

export const processSteps = [
  {
    number: 1,
    title: 'System Audit',
    description: 'We analyze your current sales process to identify weaknesses we can fix and strengths we can replicate with the AI system.'
  },
  {
    number: 2,
    title: 'Build & Integrate',
    description: 'Our team creates your custom AI agents and integrates them seamlessly with your existing CRM and calendar systems.'
  },
  {
    number: 3,
    title: 'Launch & Optimize',
    description: 'This is the most important part. We work with you side by side, providing ongoing support and performance monitoring to maximize results.'
  }
];

export const integrations = [
  { name: 'Asana', logo: 'https://cdn.worldvectorlogo.com/logos/asana-logo.svg' },
  { name: 'Salesforce', logo: 'https://cdn.worldvectorlogo.com/logos/salesforce-2.svg' },
  { name: 'PipeDrive', logo: 'https://cdn.worldvectorlogo.com/logos/pipedrive-1.svg' },
  { name: 'Monday', logo: 'https://cdn.worldvectorlogo.com/logos/monday-1.svg' },
  { name: 'HubSpot', logo: 'https://cdn.worldvectorlogo.com/logos/hubspot.svg' },
  { name: 'GoHighLevel', logo: 'https://images.g2crowd.com/uploads/product/image/large_detail/large_detail_f5e0ae23aabd22dba6b0cccaf07f3af7/highlevel.png' }
];

export const availableTimeslots = [
  '9:00 AM', '9:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM',
  '12:00 PM', '12:30 PM', '1:00 PM', '1:30 PM', '2:00 PM', '2:30 PM',
  '3:00 PM', '3:30 PM', '4:00 PM', '4:30 PM', '5:00 PM'
];
